/* eslint-disable */ 
const state = {
    showModal: true, 
};

const mutations = {
    SET_MODAL_DATA(state, payload) {
        state.showModal = payload.showModal ; 
    }
};

const actions = {
    setModalData({ commit }, payload) {
        commit('SET_MODAL_DATA', payload);
    }
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/utils.js